import {ImageView} from './ImageView';
import {ChapterImage as chapterImageTemplate } from 'templates/components/image';

export {Image} from './Image';
export {ChapterImage} from './ChapterImage';


export const imageRegistrations = {
    'Image': ImageView,
    'ChapterImage': { template: chapterImageTemplate }
}
